"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetListResponseSchema = exports.CreateWidgetInputSchema = exports.WidgetDomainSchema = exports.DashboardListResponseSchema = exports.DashboardDomainSchema = exports.OwnerEnum = exports.DashboardDefinitionSchema = exports.DashboardDefinitionWidgetSchema = exports.DashboardDefinitionPresetWidgetSchema = exports.DashboardDefinitionWidgetWidgetSchema = exports.ChartConfigSchema = exports.MetricSchema = exports.DimensionSchema = exports.PivotTableChartConfig = exports.HistogramChartConfig = exports.BigNumberChartConfig = exports.PieChartConfig = exports.VerticalBarChartConfig = exports.HorizontalBarChartConfig = exports.AreaChartTimeSeriesConfig = exports.BarChartTimeSeriesConfig = exports.LineChartTimeSeriesConfig = exports.BaseTotalValueChartConfig = exports.BaseTimeSeriesChartConfig = void 0;
const client_1 = require("@prisma/client");
const zod_1 = require("zod");
const __1 = require("../../../");
exports.BaseTimeSeriesChartConfig = zod_1.z.object({});
exports.BaseTotalValueChartConfig = zod_1.z.object({
    row_limit: zod_1.z.number().int().positive().lte(1000).optional(),
});
exports.LineChartTimeSeriesConfig = exports.BaseTimeSeriesChartConfig.extend({
    type: zod_1.z.literal("LINE_TIME_SERIES"),
});
exports.BarChartTimeSeriesConfig = exports.BaseTimeSeriesChartConfig.extend({
    type: zod_1.z.literal("BAR_TIME_SERIES"),
});
exports.AreaChartTimeSeriesConfig = exports.BaseTimeSeriesChartConfig.extend({
    type: zod_1.z.literal("AREA_TIME_SERIES"),
});
exports.HorizontalBarChartConfig = exports.BaseTotalValueChartConfig.extend({
    type: zod_1.z.literal("HORIZONTAL_BAR"),
    show_value_labels: zod_1.z.boolean().optional(),
});
exports.VerticalBarChartConfig = exports.BaseTotalValueChartConfig.extend({
    type: zod_1.z.literal("VERTICAL_BAR"),
});
exports.PieChartConfig = exports.BaseTotalValueChartConfig.extend({
    type: zod_1.z.literal("PIE"),
});
exports.BigNumberChartConfig = exports.BaseTotalValueChartConfig.extend({
    type: zod_1.z.literal("NUMBER"),
});
exports.HistogramChartConfig = exports.BaseTotalValueChartConfig.extend({
    type: zod_1.z.literal("HISTOGRAM"),
    bins: zod_1.z.number().int().min(1).max(100).optional().default(10),
});
exports.PivotTableChartConfig = exports.BaseTotalValueChartConfig.extend({
    type: zod_1.z.literal("PIVOT_TABLE"),
    defaultSort: zod_1.z
        .object({
        column: zod_1.z.string(),
        order: zod_1.z.enum(["ASC", "DESC"]),
    })
        .optional(),
});
// Define dimension schema
exports.DimensionSchema = zod_1.z.object({
    field: zod_1.z.string(),
});
// Define metric schema
exports.MetricSchema = zod_1.z.object({
    measure: zod_1.z.string(),
    agg: zod_1.z.string(),
});
// Define chart config schema based on chart type
exports.ChartConfigSchema = zod_1.z.discriminatedUnion("type", [
    exports.LineChartTimeSeriesConfig,
    exports.BarChartTimeSeriesConfig,
    exports.AreaChartTimeSeriesConfig,
    exports.HorizontalBarChartConfig,
    exports.VerticalBarChartConfig,
    exports.PieChartConfig,
    exports.BigNumberChartConfig,
    exports.HistogramChartConfig,
    exports.PivotTableChartConfig,
]);
exports.DashboardDefinitionWidgetWidgetSchema = zod_1.z.object({
    type: zod_1.z.literal("widget"),
    id: zod_1.z.string(),
    widgetId: zod_1.z.string(),
    x: zod_1.z.number().int().gte(0),
    y: zod_1.z.number().int().gte(0),
    x_size: zod_1.z.number().int().positive(),
    y_size: zod_1.z.number().int().positive(),
});
// A "preset" placement renders a registered curated component (looked up by
// presetId in the web preset registry) instead of a DashboardWidget row —
// presets carry no query configuration.
exports.DashboardDefinitionPresetWidgetSchema = zod_1.z.object({
    type: zod_1.z.literal("preset"),
    id: zod_1.z.string(),
    presetId: zod_1.z.string(),
    x: zod_1.z.number().int().gte(0),
    y: zod_1.z.number().int().gte(0),
    x_size: zod_1.z.number().int().positive(),
    y_size: zod_1.z.number().int().positive(),
});
exports.DashboardDefinitionWidgetSchema = zod_1.z.discriminatedUnion("type", [
    exports.DashboardDefinitionWidgetWidgetSchema,
    exports.DashboardDefinitionPresetWidgetSchema,
]);
exports.DashboardDefinitionSchema = zod_1.z.object({
    widgets: zod_1.z.array(exports.DashboardDefinitionWidgetSchema),
});
exports.OwnerEnum = zod_1.z.enum(["PROJECT", "ENTELLICA"]);
// Define the dashboard domain object
exports.DashboardDomainSchema = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
    createdBy: zod_1.z.string().nullable(),
    updatedBy: zod_1.z.string().nullable(),
    projectId: zod_1.z.string().nullable(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    definition: exports.DashboardDefinitionSchema,
    filters: zod_1.z.array(__1.singleFilter).default([]),
    owner: exports.OwnerEnum,
});
// Define the dashboard list response
exports.DashboardListResponseSchema = zod_1.z.object({
    dashboards: zod_1.z.array(exports.DashboardDomainSchema),
    totalCount: zod_1.z.number(),
});
// Define the widget domain object
exports.WidgetDomainSchema = zod_1.z.object({
    id: zod_1.z.string(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
    createdBy: zod_1.z.string().nullable(),
    updatedBy: zod_1.z.string().nullable(),
    projectId: zod_1.z.string().nullable(),
    name: zod_1.z.string(),
    description: zod_1.z.string(),
    view: zod_1.z.enum(client_1.DashboardWidgetViews),
    dimensions: zod_1.z.array(exports.DimensionSchema),
    metrics: zod_1.z.array(exports.MetricSchema),
    filters: zod_1.z.array(__1.singleFilter),
    chartType: zod_1.z.enum(client_1.DashboardWidgetChartType),
    chartConfig: exports.ChartConfigSchema,
    minVersion: zod_1.z.number().int().default(1),
    owner: exports.OwnerEnum,
});
// Define create widget input schema
exports.CreateWidgetInputSchema = zod_1.z.object({
    name: zod_1.z.string().min(1, "Widget name is required"),
    description: zod_1.z.string(),
    view: zod_1.z.enum(client_1.DashboardWidgetViews),
    dimensions: zod_1.z.array(exports.DimensionSchema),
    metrics: zod_1.z.array(exports.MetricSchema),
    filters: zod_1.z.array(__1.singleFilter),
    chartType: zod_1.z.enum(client_1.DashboardWidgetChartType),
    chartConfig: exports.ChartConfigSchema,
    minVersion: zod_1.z.number().int().optional(),
});
// Define the widget list response
exports.WidgetListResponseSchema = zod_1.z.object({
    widgets: zod_1.z.array(exports.WidgetDomainSchema),
    totalCount: zod_1.z.number(),
});
